import { IconProps } from '../../types/IconProps';

export const FiltersInactive = ({ variant, className }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='25'
    fill='none'
    className={`${className || ''}`}>
    <path
      fill={variant === 'light' ? '#fff' : '#0B223E'}
      d='M17.985 12a.665.665 0 0 1-.665.665H6.68a.665.665 0 0 1 0-1.33h10.64c.367 0 .665.298.665.665Zm2.66-4.655H3.355a.665.665 0 1 0 0 1.33h17.29a.665.665 0 0 0 0-1.33Zm-6.65 7.98h-3.99a.665.665 0 1 0 0 1.33h3.99a.665.665 0 0 0 0-1.33Z'
    />
  </svg>
);
